import { createFileRoute } from "@tanstack/react-router";

import { AuthProvider } from "@/providers/auth.provider";
import { PersonaEntry } from "@/features/dashboard/components/persona-entry";

export const Route = createFileRoute("/management")({
  component: () => (
    <AuthProvider>
      <PersonaEntry surface="management" />
    </AuthProvider>
  ),
});
